import React from 'react';
import { Navigation } from './components/Navigation';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Expertise } from './components/Expertise';
import { CaseStudies } from './components/CaseStudies';
import { Testimonials } from './components/Testimonials';
import { Contact } from './components/Contact';
export function App() {
  return <div className="min-h-screen bg-primary selection:bg-accent selection:text-white" data-id="element-0">
      <Navigation data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Expertise data-id="element-5" />
        <CaseStudies data-id="element-6" />
        <Testimonials data-id="element-7" />
      </main>
      <Contact data-id="element-8" />
      <footer className="bg-dark text-gray-500 py-8 text-center text-sm border-t border-white/10" data-id="element-9">
        <p data-id="element-10">
          © {new Date().getFullYear()} Sarah Jenkins. Designed with structured
          clarity.
        </p>
      </footer>
    </div>;
}